module.exports = __webpack_public_path__ + "img/menu.bf38c623.png";